<div id="tabHeadData"  [formGroup]="form">
    <div class="row" >
        <div class="col-md-12 col-xs-12 group">                
            <div class="row">
                <div class="col-md-12 col-xs-12 group-title">
                    <h5>מילוי נתונים אישיים</h5>
                </div>
            </div>
            <personal-info [form]="form" [isSocialID_Mandarory]="isSocialID_Mandarory" relation= "ממלא הטופס"></personal-info>
            <div class="row">
                <div class="col-md-6 col-xs-12">
                    <div class="controls-group">                        
                            <label mandatory>
                                תאריך יציאה
                            </label>
                            <div class="input-group">
                                <input type="text" class="form-control datepicker" autocomplete="off" 
                                    bsDatepicker [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD/MM/YYYY' }"
                                    #dpd="bsDatepicker" formControlName="departure_date" 
                                >
                                <span class="input-group-prepend">
                                    <span class="input-group-text" >
                                        <i class="fa fa-calendar"></i>
                                    </span>
                                </span>
                                <control-messages [control]="f.departure_date"></control-messages>
                            </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-xs-12">
                    <div class="controls-group">                        
                            <label mandatory>
                                מצב משפחתי
                            </label>
                            <div class="input-group">
                                <select class="form-control" formControlName="marital_status" (change)="maritalStatusChanged()" >
                                    <option value="" disabled selected>בחר מצב משפחתי</option>
                                    <option *ngFor="let item of baseService.MaritalStatuses" value="{{item.KOD}}">{{item.TEUR}}</option>
                                </select>                                            
                                <span class="input-group-prepend">
                                    <span class="input-group-text" >
                                        <i class="fa fa-angle-down fa-lg"></i>
                                    </span>
                                </span>
                                <control-messages [control]="f.marital_status"></control-messages>
                            </div>
                    </div>
                </div>
                <div class="col-md-6 col-xs-12">
                    <div class="controls-group" *ngIf="f.marital_status && f.marital_status.value == '2'">     
                        <yes-no [form]="form" controlName="partner_returning" 
                                text="בן / בת זוג חוזר/ת לארץ">
                        </yes-no> 
                    </div>                    
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-xs-12">
                    <div class="controls-group">                        
                            <label mandatory>
                                שירות צבאי
                            </label>
                            <div class="input-group">
                                <select class="form-control" formControlName="army_service" (change)="armyServiceChanged()" >
                                    <option value="" disabled selected>בחר שירות צבאי</option>
                                    <option *ngFor="let item of baseService.ArmyServices" value="{{item.KOD}}">{{item.TEUR}}</option>
                                </select>
                                <span class="input-group-prepend">
                                    <span class="input-group-text" >
                                        <i class="fa fa-angle-down fa-lg"></i>
                                    </span>
                                </span>    
                                <control-messages [control]="f.army_service"></control-messages>
                            </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="f.army_service && (('1' == f.army_service.value) || ('5' == f.army_service.value))">
                    <div class="col-md-12 col-xs-12">
                            <div class="controls-group">                        
                                <div class="input-group">
                                        <textarea type="text" class="form-control txt" 
                                            formControlName="content" maxlength="600"
                                            placeholder="יש לכתוב הסבר"
                                        >
                                        </textarea>
                                        <control-messages [control]="f.content"></control-messages>
                                    </div>
                            </div>
                    </div>
            </div>
            <div class="row">
                    <div class="col-md-12 col-xs-12">
                            <yes-no [form]="form" controlName="gov_check" 
                                    text="בחמש השנים לפני חזרתי ארצה, הועסקתי על ידי משרד ממשלתי ו/או מעסיק ישראלי, כך ששולמו עבור עבודתי מיסים לרשויות המס בישראל">
                            </yes-no>                        
                    </div>
            </div>
            <div class="row">
                    <div class="col-md-12 col-xs-12">
                            <div class="controls-group-h">
                                <label class="form-check-label">                           
                                    מספר ילדים אשר ביום חזרתם יהיו בני 0-16                               
                                </label>  
                                <input type="text" class="small-form-control" maxlength="2"
                                    formControlName="children_up16_num"
                                    placeholder="0"
                                />                              
                            </div>
                    </div>
            </div>
            <div class="row">
                    <div class="col-md-12 col-xs-12">
                            <div class="controls-group-h">
                                <label class="form-check-label">                           
                                    מספר ילדים אשר ביום חזרתם יהיו בני 16-18                                
                                </label>  
                                <input type="text" class="small-form-control" maxlength="2"
                                    formControlName="children_up18_num" (change)="childrenUp18NumberChanged()"
                                    placeholder="0" 
                                />                              
                            </div>
                    </div>
            </div>
            <div class="row">
                    <div class="col-md-12 col-xs-12">
                        <yes-no [form]="form" controlName="moia_donation" 
                                text="קיבלתי בעבר סיוע כעולה ממשרד העלייה והקליטה">
                        </yes-no>                             
                    </div>
            </div>
            <div class="row">
                    <div class="col-md-12 col-xs-12">
                        <yes-no [form]="form" controlName="returning_donation" 
                                text="קיבלתי בעבר סיוע כתושב חוזר ממשרד העלייה והקליטה">
                        </yes-no>   
                    </div>
            </div>
            <div class="row">
                    <div class="col-md-12 col-xs-12">
                        <yes-no [form]="form" controlName="scientist" 
                                text="האם יש מדען במשפחה (אחד מבני הזוג)">
                        </yes-no>
                    </div>
                    <br>
            </div>
            <br>
        </div>
    
        <div class="col-md-12 col-xs-12 group">                
            <div class="row">
                <div class="col-md-12 col-xs-12 group-title">
                    <h5>פרטי התקשרות</h5>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-xs-12">
                    <div class="controls-group">                        
                        <label mandatory>
                            ארץ מגורים
                        </label>
                        <app-find [list]="baseService.Countries" [control]="f.residence_country"
                            id="residence_country" vkposition="left"
                            (changed)="selectedCounrty_changed()" >
                        </app-find>
                    </div>
                </div>


                <div class="col-md-6 col-xs-12">
                        <div class="controls-group">                        
                                <label>
                                    מדינה
                                </label>
                                <div class="input-group">
                                    <app-find [list]="baseService.USA_States" [control]="f.state"
                                        id="state" withVirtualKeyboard="false" [disabled]="f.state.disabled" [isHebrewOnly]="false">
                                    </app-find>
                                    <control-messages [control]="f.state"></control-messages>
                                </div>
                            </div>
                </div>
            </div>

            <div class="row">
                    <div class="col-md-6 col-xs-12">
                    <div class="controls-group">                        
                        <label mandatory>
                            עיר
                        </label>
                        <div class="input-group">
                            <input type="text" class="form-control txt" maxlength="25" 
                                formControlName="city"
                                placeholder="אנגלית"
                            />
                            <control-messages [control]="f.city"></control-messages>
                        </div>
                    </div>
                    </div>
            </div>
            <div class="row">
                    <div class="col-md-6 col-xs-12">
                    <div class="controls-group">                        
                        <label mandatory>
                            טלפון ראשי
                        </label>
                        <div class="input-group">
                            <input type="text" class="form-control txt" maxlength="20" 
                                formControlName="phone_main" 
                            />
                            <control-messages  [control]="f.phone_main"></control-messages>
                        </div>
                    </div>
                    </div>
                <div class="col-md-6 col-xs-12">
                        <div class="controls-group">                        
                                <label>
                                    טלפון משני
                                </label>
                                <div class="input-group">
                                    <input type="text" class="form-control txt" maxlength="20" 
                                        formControlName="phone_adv"
                                    />
                                    <control-messages [control]="f.phone_adv"></control-messages>
                                </div>
                            </div>
                </div>
            </div>
            <div class="row">
                    <div class="col-md-6 col-xs-12">
                    <div class="controls-group">                        
                        <label mandatory>
                            דואר אלקטרוני
                        </label>
                        <div class="input-group">
                            <input type="text" class="form-control txt" maxlength="50" 
                                formControlName="email"
                            />
                            <control-messages [control]="f.email"></control-messages>
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-xs-12">
                    <div class="controls-group">                        
                        <label mandatory>
                            בשובי ארצה אני מתכוון להתגורר ב
                        </label>
                        <app-find [list]="baseService.IsraelCities" [control]="f.probable_city"
                            id="probable_city" vkposition="top">
                        </app-find>
                    </div>

                </div>
            </div>
            <br>
      
        <div class="row">
            <div class="col-md-12 col-xs-12 group"> 
                <last-works [form]="form"></last-works>  
            </div>
        </div>
        
    </div>
</div>